<script setup lang="ts">
import type Article from "~/types/Article";
import ArticleHeader from "~/components/articles/ArticleHeader.vue";
import ArticleContent from "~/components/articles/ArticleContent.vue";
import type { Ref } from "vue";
import { useArticle } from "~/composables/article";

const route = useRoute();
const slugArticle = route.params.article ?? "";
const article: Ref<Article | null> = ref(null);

const { searchText, updateUrl, result, fetchResult } = useArticle();
updateUrl.value = false; // Set to false to prevent updating the URL when user types in the search input

const collections = await useHelper().getCollection("articles", `filter[slug:is]=${slugArticle}`, 1);
if (collections && collections.length > 0) {
    article.value = collections[0] as Article;
}

const articles = computed(() => {
    return result.value?.data ? (result.value.data as Article[]) : [];
});

await fetchResult();
</script>

<template>
    <div>
        <div v-if="article">
            <div class="flex-1 pb-16 md:mr-4">
                <ArticleHeader :article="article" />
                <ArticleContent
                    :article-content-blocks="article.content"
                    class="prose mx-auto max-w-none md:max-w-3xl xl:max-w-4xl"
                />
            </div>
        </div>
        <div v-else class="text-center">Sorry, we couldn't find the article you were looking for...</div>
    </div>
</template>

<style scoped></style>
